import { forwardRef, RefObject, useEffect } from 'react';

import { useSelector } from 'react-redux';

import ReduxState from 'store/ReduxState';

const SeekHandler = forwardRef(
  (_props, { current }: RefObject<HTMLAudioElement>) => {
    const seekTo = useSelector<ReduxState>(({ player }) => player.seekTo);

    useEffect(() => {
      if (current && seekTo !== undefined) {
        current.currentTime = seekTo as number;
      }
    });

    return null;
  },
);

export default SeekHandler;
